import { useMemo } from 'react';

interface Sparkle {
  id: number;
  x: number;
  y: number;
  size: number;
  delay: number;
  duration: number;
  color: 'purple' | 'white';
}

interface SparkleBackgroundProps {
  count?: number;
  className?: string;
}

export function SparkleBackground({ count = 18, className }: SparkleBackgroundProps) {
  const prefersReducedMotion = typeof window !== 'undefined' 
    && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const sparkles = useMemo<Sparkle[]>(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: 2 + Math.random() * 2,
      delay: Math.random() * 3,
      duration: 3 + Math.random() * 3,
      color: Math.random() > 0.3 ? 'purple' : 'white',
    }));
  }, [count]);

  return (
    <div 
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className ?? ''}`}
      style={{ zIndex: 5 }}
      aria-hidden="true"
    >
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          className="absolute rounded-full animate-sparkle-pulse"
          style={{
            left: `${sparkle.x}%`,
            top: `${sparkle.y}%`,
            width: sparkle.size,
            height: sparkle.size,
            backgroundColor: sparkle.color === 'purple' 
              ? 'hsl(270 70% 60%)' 
              : 'hsl(0 0% 100%)',
            animationDuration: prefersReducedMotion ? '0s' : `${sparkle.duration}s`,
            animationDelay: prefersReducedMotion ? '0s' : `${sparkle.delay}s`,
            opacity: prefersReducedMotion ? 0.2 : undefined,
          }}
        />
      ))}
    </div>
  );
}
